/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Spaces_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Add files to a space and embed them, then @-mention the space in a chat. With auto-embed on, uploads are ready immediately; otherwise embed them from the too..." |
*
* @param {Uno_Edu_Intro_Spaces_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_spaces_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Spaces_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Spaces_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Dateien einem Space hinzu und betten Sie sie ein, und erwähnen Sie dann den Space mit @ in einem Chat. Mit aktivierter automatischer Einbettung sind Uploads sofort bereit; andernfalls betten Sie sie über die Symbolleiste ein.")
	return /** @type {LocalizedString} */ ("Add files to a space and embed them, then @-mention the space in a chat. With auto-embed on, uploads are ready immediately; otherwise embed them from the toolbar.")
});